import styled from 'styled-components'

const CardBody = styled.div`
  padding: 10px 0px;
`

export default CardBody
